import React from "react";
import { Squash } from "hamburger-react";
import { Container } from "./style";
import { MenuLinks } from "../../MenuLinks";

export const HamburgerLinks = ({ toggled, toggle }) => {
  return (
    <Container>
      <Squash toggled={toggled} toggle={toggle} />
      <MenuLinks toggled={toggled} toggle={toggle} />
    </Container>
  );
};
